function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  role: "img"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#6D6D6D",
  transform: "matrix(.9 0 0 .9 15 15)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 26,
  x: -1,
  y: -13,
  rx: 1,
  transform: "rotate(-45)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 26,
  x: -1,
  y: -13,
  rx: 1,
  transform: "rotate(45)"
})));
export default "/Users/mgomezlucero/Work/SkedGo/Projects/tripkit-react/src/images/ic-cross.svg";
export { SvgComponent as ReactComponent };